import { $api } from "../generated/client";

export default function useShopifyEmbedStatus(shopId?: string | null) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/shopify-embed-status",
		{
			params: { path: { shopId: shopId! } },
		},
		{
			enabled: !!shopId,
			// The merchant enables the embed in another tab: recheck on return, but only while
			// it is inactive, so active or unreadable shops do not hit Shopify on every focus.
			refetchOnWindowFocus: (query) =>
				query.state.data?.status === "inactive" ? "always" : false,
		},
	);
}
